import React from 'react'
import './Mainbody.css'

export const Mainbody = ({ setloading }) => {

    const OnLoad = () => {
        setTimeout(() => {
            setloading(false);
            document.body.style.overflow = "auto"
        }, 2000)
    }

    return (
        <div id="home">
            <div className="main-body">
                <div className="left">
                    <div>
                        <section>REACT</section>
                        <section>REDUX</section>
                        <section>DJANGO</section>
                        <section>THREE.JS</section>
                    </div>
                    <div>
                        <section>FLUTTER</section>
                        <section>REACT NATIVE</section>
                        <section>C/C++</section>
                    </div>
                    <div style={{ fontFamily: "'Roboto Mono', monospace" }}>
                        <p className="H1">
                            The way you Code can tell much about You!
                        </p>
                        <p className="H5">
                            <strong style={{ color: "#65f4ad" }}>President Codechef PCCOE Chapter</strong>
                            {/*     | <strong style={{ color: "#65f4ad" }}></strong> | <strong style={{ color: "#65f4ad" }}></strong> */}
                        </p>
                        <p className="H2">
                            I am an MERN Stack Web Developer and Python Intermediate.<br />
                            I like fixing problems and finding solutions. I always like trying new Technologies
                        </p>
                        <p className="H3">
                            <strong style={{ color: "#65f4ad" }}>6+ </strong>Projects
                        </p>
                        <p className="H4">
                            <strong style={{ color: "#65f4ad" }}>3+ </strong>Years Experience
                        </p>
                    </div>

                </div>
                <div className="right" id="main">

                    <div>
                        {/* <Sphere/> */}
                        <section className="lang1">
                            <img src="https://img.icons8.com/color/128/000000/django.png" alt="" />
                        </section>
                        <section className="lang2">
                            <img src="https://img.icons8.com/color/150/000000/python--v2.png" alt="" onLoad={OnLoad} />
                        </section>
                        <section className="lang4">
                            <img src="https://img.icons8.com/color/150/000000/c-plus-plus-logo.png" alt="" />
                        </section>
                        <section className="lang5">
                            <img src="https://img.icons8.com/color/150/26e07f/react-native.png" alt="" />
                        </section>
                        <section className="lang3" >
                            <img src="https://img.icons8.com/windows/96/26e07f/node-js.png" alt="" />
                        </section>
                        <section className="lang6">
                            <img src="https://img.icons8.com/color/144/26e07f/css3.png" alt="" />
                        </section>
                        <section className="lang7" >
                            <img src="https://img.icons8.com/color/144/26e07f/html-5--v1.png" alt="" />
                        </section>
                        <section className="lang8">
                            <img src="https://img.icons8.com/color/144/26e07f/java-coffee-cup-logo--v1.png" alt="" />
                        </section>
                        <section className="lang9">
                            <img src="https://img.icons8.com/color/144/26e07f/flutter.png" alt="" />
                        </section>
                        <section className="lang10">
                            <img src="https://img.icons8.com/color/144/000000/firebase.png" alt="" />
                        </section>
                    </div>

                </div>

            </div>
        </div>
    )
}
